<template>
  <div v-if="field.products" class="ProductList2">
    <section class="section home-section bg white pb-sm-5 pb-0 px-3 mb-sm-3 px-sm-0">
      <div class="inner-wrap container bg white pb-1 pb-lg-0">
        <div class="products-list set-2 row">
          <div class="products-list__column col-lg-6">
            <div class="item">
              <div v-if="field.products[0]" class="product type-c">
                <div class="row">
                  <div class="col-5 product__img">
                    <div class="row">
                      <div class="thumb">
                        <router-link :to="'products/item/'+field.products[0].id">
                          <img
                            v-if="field.products[0].images[0]"
                            :src="[ field.products[0].images[0].url]"
                          >
                          <img v-else src="../../assets/img/default-noimg.png">
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="col-7 product__content">
                    <div class="row">
                      <div class="px-2 pt-2 description w-100">
                        <h5 class="ui text big-lg medium-md tiny-sm small semibold">
                          <router-link
                            :to="'products/item/'+field.products[0].id"
                          >{{field.products[0].titleTH}}</router-link>
                        </h5>
                        <p
                          class="ui text medium-lg tiny-md small-sm tiny light color gray-7"
                        >{{field.products[0].codeDetailTH}}</p>
                      </div>
                      <div class="d-flex align-items-center mt-2 px-2 col-12">
                        <div class="price">
                          <p
                            class="ui text big-lg medium-md tiny-sm small bold [ color red-2 ] m-0"
                          >{{currency}}{{formatPrice(field.products[0].netPrice)}}</p>
                          <p
                            v-if="field.products[0].netPrice != field.products[0].price"
                            class="ui text big-lg medium-md tiny-sm small light line-through m-0"
                          >{{currency}}{{formatPrice(field.products[0].price)}}</p>
                        </div>
                        <div class="ml-auto btns">
                          <AddToCart
                            v-if="field.products[0].quantity != 0"
                            :btnStyle="'style1'"
                            :product="field.products[0]"
                          />
                          <span v-else class="badge badge-danger mr-2">{{$t('SoldOut')}}</span>
                          <Favorite :productId="field.products[0].id"></Favorite>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div v-if="field.products[1]" class="product type-c">
                <div class="row">
                  <div class="col-5 product__img">
                    <div class="row">
                      <div class="thumb">
                        <router-link :to="'products/item/'+field.products[1].id">
                          <img
                            v-if="field.products[1].images[0]"
                            :src="[ field.products[1].images[0].url]"
                          >
                          <img v-else src="../../assets/img/default-noimg.png">
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="col-7 product__content">
                    <div class="row">
                      <div class="px-2 pt-2 description w-100">
                        <h5 class="ui text big-lg medium-md tiny-sm small semibold">
                          <router-link
                            :to="'products/item/'+field.products[1].id"
                          >{{field.products[1].titleTH}}</router-link>
                        </h5>
                        <p
                          class="ui text medium-lg tiny-md small-sm tiny light color gray-7"
                        >{{field.products[1].codeDetailTH}}</p>
                      </div>
                      <div class="d-flex align-items-center mt-2 px-2 col-12">
                        <div class="price">
                          <p
                            class="ui text big-lg medium-md tiny-sm small bold [ color red-2 ] m-0"
                          >{{currency}}{{formatPrice(field.products[1].netPrice)}}</p>
                          <p
                            v-if="field.products[1].netPrice != field.products[1].price"
                            class="ui text big-lg medium-md tiny-sm small light line-through m-0"
                          >{{currency}}{{formatPrice(field.products[1].price)}}</p>
                        </div>
                        <div class="ml-auto btns">
                          <AddToCart
                            v-if="field.products[1].quantity != 0"
                            :btnStyle="'style1'"
                            :product="field.products[1]"
                          />
                          <span v-else class="badge badge-danger mr-2">{{$t('SoldOut')}}</span>
                          <Favorite :productId="field.products[1].id"></Favorite>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="products-list__column col-lg-6">
            <div class="item">
              <div v-if="field.products[2]" class="product type-c">
                <div class="row">
                  <div class="col-5 product__img">
                    <div class="row">
                      <div class="thumb">
                        <router-link :to="'products/item/'+field.products[2].id">
                          <img
                            v-if="field.products[2].images[0]"
                            :src="[ field.products[2].images[0].url]"
                          >
                          <img v-else src="../../assets/img/default-noimg.png">
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="col-7 product__content">
                    <div class="row">
                      <div class="px-2 pt-2 description w-100">
                        <h5 class="ui text big-lg medium-md tiny-sm small semibold">
                          <router-link
                            :to="'products/item/'+field.products[2].id"
                          >{{field.products[2].titleTH}}</router-link>
                        </h5>
                        <p
                          class="ui text medium-lg tiny-md small-sm tiny light color gray-7"
                        >{{field.products[2].codeDetailTH}}</p>
                      </div>
                      <div class="d-flex align-items-center mt-2 px-2 col-12">
                        <div class="price">
                          <p
                            class="ui text big-lg medium-md tiny-sm small bold [ color red-2 ] m-0"
                          >{{currency}}{{formatPrice(field.products[2].netPrice)}}</p>
                          <p
                            v-if="field.products[2].netPrice != field.products[2].price"
                            class="ui text big-lg medium-md tiny-sm small light line-through m-0"
                          >{{currency}}{{formatPrice(field.products[2].price)}}</p>
                        </div>
                        <div class="ml-auto btns">
                          <AddToCart
                            v-if="field.products[2].quantity != 0"
                            :btnStyle="'style1'"
                            :product="field.products[2]"
                          />
                          <span v-else class="badge badge-danger mr-2">{{$t('SoldOut')}}</span>
                          <Favorite :productId="field.products[2].id"></Favorite>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div v-if="field.products[3]" class="product type-c">
                <div class="row">
                  <div class="col-5 product__img">
                    <div class="row">
                      <div class="thumb">
                        <router-link :to="'products/item/'+field.products[3].id">
                          <img
                            v-if="field.products[3].images[0]"
                            :src="[ field.products[3].images[0].url]"
                          >
                          <img v-else src="../../assets/img/default-noimg.png">
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="col-7 product__content">
                    <div class="row">
                      <div class="px-2 pt-2 description w-100">
                        <h5 class="ui text big-lg medium-md tiny-sm small semibold">
                          <router-link
                            :to="'products/item/'+field.products[3].id"
                          >{{field.products[3].titleTH}}</router-link>
                        </h5>
                        <p
                          class="ui text medium-lg tiny-md small-sm tiny light color gray-7"
                        >{{field.products[3].codeDetailTH}}</p>
                      </div>
                      <div class="d-flex align-items-center mt-2 px-2 col-12">
                        <div class="price">
                          <p
                            class="ui text big-lg medium-md tiny-sm small bold [ color red-2 ] m-0"
                          >{{currency}}{{formatPrice(field.products[3].netPrice)}}</p>
                          <p
                            v-if="field.products[3].netPrice != field.products[3].price"
                            class="ui text big-lg medium-md tiny-sm small light line-through m-0"
                          >{{currency}}{{formatPrice(field.products[3].price)}}</p>
                        </div>
                        <div class="ml-auto btns">
                          <AddToCart
                            v-if="field.products[3].quantity != 0"
                            :btnStyle="'style1'"
                            :product="field.products[3]"
                          />
                          <span v-else class="badge badge-danger mr-2">{{$t('SoldOut')}}</span>
                          <Favorite :productId="field.products[3].id"></Favorite>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import AddToCart from "@/components/cart/AddItem.vue";
import Favorite from "@/components/favorite/AddFavorite.vue";

export default {
  name: "ProductListII",
  components: {
    AddToCart,
    Favorite
  },
  props: {
    field: {
      type: Object,
      default: {
        products: {
          type: Array,
          default: () => []
        }
      }
    }
  },
  data() {
    return {
      product: {},
      currency: ""
    };
  },
  created() {
    // console.log(this.field.products)
    this.currency = this.$parent.currency;
  },
  methods: {
    formatPrice(value) {
      let price = Number(value);
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
</script>
<style lang="scss">
.product.type-c .product__content .description p {
  word-wrap: break-word;
}
</style>